export default __webpack_public_path__ + "static/media/style.75f7e5ab.less";